import React from 'react';
import { TextBlock } from 'react-placeholder/lib/placeholders';

const FooterTopPlaceholder = () => {
    return <footer className="tb--placeholder footer-container footer-container-pl">
        <div className="footer">
            <div className='footer--top-placeholder'>
                <div className='footer--pl-row tb--show-animation'>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '70%', marginBottom: '14px'}} />
                        <TextBlock style={{ width: '100%' }} />
                    </div>
                    <div  className='footer--pl-col-28'>
                        <TextBlock style={{ width: '100%', margin: '0 auto 14px'}} />
                        <TextBlock style={{ width: '50%', margin: '0 auto' }} />
                    </div>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '70%' , marginBottom: '14px', marginLeft: 'auto'}} />
                        <TextBlock style={{ width: '100%' }} />
                    </div>
                </div>
                <div className='footer--pl-row tb--show-animation'>
                     <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '100%' , marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%', marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%'}} />
                    </div>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '100%' , marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%', marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%'}} />
                    </div>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '100%' , marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%', marginBottom: '14px'}} />
                        <TextBlock style={{ width: '70%'}} />
                    </div>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '100%', marginBottom: '14px', marginLeft: 'auto'}} />
                        <TextBlock style={{ width: '70%', marginBottom: '14px', marginLeft: 'auto'}} />
                        <TextBlock style={{ width: '70%', marginLeft: 'auto'}} />
                    </div>
                </div>
                <div className='footer--pl-row tb--show-animation'>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '70%'}} />
                    </div>
                    <div  className='footer--pl-col-28'>
                        <TextBlock style={{ width: '50%', margin: '0 auto 14px'}} />
                        <TextBlock style={{ width: '100%', margin: '0 auto' }} />
                    </div>
                    <div className='footer--pl-col-15'>
                        <TextBlock style={{ width: '70%', marginLeft: 'auto'}} />
                    </div>
                </div>
            </div>
        </div>
    </footer>

}

const FooterMiddlePlaceholder = (
    <div className='footer--middle-placeholder tb--show-animation'>
        <TextBlock rows={3} />
    </div>
);

const PaymentProviderPlaceholder = (
    <div className='footer--pp-placeholder tb--flex tb--justify-center tb--show-animation'>
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />
        <TextBlock style={{ width: '100px', height: '64px' }} />

    </div>
);
const ImageBlockPlaceholder = (
    <div className='footer--pp-placeholder tb--flex tb--justify-center tb--show-animation tb--image-block_plc'>
        <TextBlock />
        <TextBlock />
        <TextBlock />
        <TextBlock />
        <TextBlock />
        <TextBlock />
        <TextBlock className="tb--mobile-hide"/>
        <TextBlock className="tb--mobile-hide"/>
        <TextBlock className="tb--mobile-hide"/>
        <TextBlock className="tb--mobile-hide"/>
        <TextBlock className="tb--mobile-hide"/>
        <TextBlock className="tb--mobile-hide"/>


    </div>
);
export { FooterTopPlaceholder, FooterMiddlePlaceholder, PaymentProviderPlaceholder, ImageBlockPlaceholder }